export default __webpack_public_path__ + "static/media/SavingsFill.e90785bd.svg";